import { createFileRoute } from '@tanstack/react-router'
import UserContact from 'User/components/Sections/UserContact'

export const Route = createFileRoute('/user/$userId/contacts')({
    component: UserContact,
})
